module.exports = __webpack_public_path__ + "media/icons/account-8dba93bf.png";